import React, { createContext, useContext, useState } from 'react';

const NavbarActionContext = createContext();

export const useNavbarAction = () => {
  const context = useContext(NavbarActionContext);
  if (!context) {
    throw new Error('useNavbarAction must be used within NavbarActionProvider');
  }
  return context;
};

export const NavbarActionProvider = ({ children }) => {
  const [actionConfig, setActionConfig] = useState({
    label: null,
    onClick: null,
    icon: null,
    show: false
  });
  const [showStats, setShowStats] = useState(true);
  const [onCreateAdherent, setOnCreateAdherent] = useState(null);
  const [onCreateProspect, setOnCreateProspect] = useState(null);
  const [onCreatePatient, setOnCreatePatient] = useState(null);
  const [onCreateClient, setOnCreateClient] = useState(null);
  const [onCreateUtilisateur, setOnCreateUtilisateur] = useState(null);
  const [onCreateMateriel, setOnCreateMateriel] = useState(null);
  const [onCreateVehicule, setOnCreateVehicule] = useState(null);
  const [onCreateReclamation, setOnCreateReclamation] = useState(null);
  const [stats, setStats] = useState(null);
  const [navbarHeight, setNavbarHeight] = useState(0);
  const [userData, setUserData] = useState(null);

  const setAction = (config) => {
    setActionConfig({
      label: config.label || null,
      onClick: config.onClick || null,
      icon: config.icon || null,
      show: config.show !== undefined ? config.show : true
    });
  };

  const clearAction = () => {
    setActionConfig({
      label: null,
      onClick: null,
      icon: null,
      show: false
    });
  };

  return (
    <NavbarActionContext.Provider value={{
      actionConfig,
      setAction,
      clearAction,
      showStats,
      setShowStats,
      onCreateAdherent,
      setOnCreateAdherent,
      onCreateProspect,
      setOnCreateProspect,
      onCreatePatient,
      setOnCreatePatient,
      onCreateClient,
      setOnCreateClient,
      onCreateUtilisateur,
      setOnCreateUtilisateur,
      onCreateMateriel,
      setOnCreateMateriel,
      onCreateVehicule,
      setOnCreateVehicule,
      onCreateReclamation,
      setOnCreateReclamation,
      stats,
      setStats,
      navbarHeight,
      setNavbarHeight,
      userData,
      setUserData
    }}>
      {children}
    </NavbarActionContext.Provider>
  );
};